import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { getUbicacion, postUbicacion } from "../../../redux/actions";
import styles from "./Ubicaciones.module.css";

const Ubicaciones = () => {
  const [ubicacion, setUbicacion] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const ubicaciones = useSelector((state) => state.ubicaciones);

  useEffect(() => {
    dispatch(getUbicacion());
  }, [dispatch]);

  const handleCrearUbicacion = async () => {
    if (ubicacion.trim() === "") {
      setError("Debe ingresar un nombre de ubicación.");
      return;
    }

    try {
      await dispatch(postUbicacion(ubicacion));
      setUbicacion("");
      setError("");
      dispatch(getUbicacion()); // Refresca la lista después de crear

      Swal.fire({
        icon: "success",
        title: "Ubicación creada",
        text: "La ubicación fue creada con éxito",
        confirmButtonColor: "#3559d1"
      });

    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.error || "Ocurrió un error al crear la ubicación"
      });
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.titulo}>Ubicaciones</h2>

      <input
        type="text"
        placeholder="Escriba el nombre de la ubicación"
        value={ubicacion}
        onChange={(e) => setUbicacion(e.target.value)}
        className={styles.input}
      />

      {error && <p className={styles.error}>{error}</p>}

      <button onClick={handleCrearUbicacion} className={styles.boton}>
        Crear Ubicación
      </button>

      <label className={styles.label}>Ubicaciones registradas:</label>
      <select className={styles.select}>
        {ubicaciones?.length > 0 ? (
          ubicaciones.map((ubi) => (
            <option key={ubi.id} value={ubi.nombre}>
              {ubi.nombre}
            </option>
          ))
        ) : (
          <option disabled>No hay ubicaciones registradas</option>
        )}
      </select>
    </div>
  );
};

export default Ubicaciones;
